import AnnouncementAdminBtn from "assets/img/announment_admin_full_btn.png";
import IRISBtn from "assets/img/iris_full_btn.png";
import ManageDataBtn from "assets/img/managa_data_full_btn.png";
import ManageRequest from "assets/img/manage_request.svg";
import StoreBtn from "assets/img/store_full_btn.png";
import Constants from "helpers/constants";
import { setItem } from "helpers/storage";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { State } from "state";
import ActionCard from "./ActionCard";

import { getItem } from "helpers/storage";
import { useDispatch } from "react-redux";
import { fetchManageDataAccess } from "state/chain_user_role";
import { IMPERSONATIONUSER } from "../state/auth";
import { fetchUserActiveRequests } from "../state/request_details_dependencies";
interface QuickActionsOwnProps {
  chains?: any[];
}
type QuickActionsProps = QuickActionsOwnProps & RouteComponentProps;

const QuickActionsComponent: React.FC<QuickActionsProps> = ({ history, chains }) => {
  const authUser = useSelector((state: State) => state.auth_user.content);
  const [impersonUser, setImpersonUser] = React.useState<any>();
  const [isImpersonating, setIsImpersonating] = React.useState(false);
  const [hasManageDataAccess, setHasManageDataAccess] = React.useState(false);
  useEffect(() => {
    const syncImpersonation = () => {
      const storedUser = getItem(IMPERSONATIONUSER);

      if (!storedUser) {
        setImpersonUser(undefined);
        setIsImpersonating(false);
        return;
      }

      try {
        const parsed = JSON.parse(storedUser);
        const normalized = typeof parsed === "string" ? JSON.parse(parsed) : parsed;
        setImpersonUser(normalized);
        setIsImpersonating(true);
      } catch {
        setImpersonUser(undefined);
        setIsImpersonating(false);
      }
    };

    syncImpersonation();
    window.addEventListener("impersonation-updated", syncImpersonation);
    return () => {
      window.removeEventListener("impersonation-updated", syncImpersonation);
    };
  }, []);
  const parsedData = impersonUser || authUser;
  const effectiveUserRole = impersonUser?.role || authUser?.role;
  const userData = parsedData;

  const irisPermission =
  userData?.user_level_permissions?.includes("access_DIR") ?? false;
  const dispatch = useDispatch();
  const activeRequestCount = useSelector((state: State) => state.requestDependencies.activeRequestCount);
  useEffect(() => {
    dispatch(fetchUserActiveRequests() as any);
  }, [dispatch]);

  useEffect(() => {
    const isGlobalProjectAdmin =
      effectiveUserRole === Constants.INTERNAL_PROJECT_ADMIN ||
      effectiveUserRole === Constants.EXTERNAL_PROJECT_ADMIN;
    const impersonatedUserId = impersonUser?.id || impersonUser?.user_id || impersonUser?.user?.id;
    const userId = isImpersonating ? impersonatedUserId : authUser?.id;

    if (!isGlobalProjectAdmin || !userId) {
      setHasManageDataAccess(false);
      return;
    }

    (dispatch as any)(fetchManageDataAccess(userId))
      .then((hasAccess: boolean) => {
        setHasManageDataAccess(hasAccess);
      })
      .catch(() => {
        setHasManageDataAccess(false);
      });
  }, [
    dispatch,
    effectiveUserRole,
    isImpersonating,
    impersonUser?.id,
    impersonUser?.user_id,
    impersonUser?.user?.id,
    authUser?.id,
  ]);

  // Base actions (always visible)
  const baseActions = [
    // { icon: IRISBtn, label: "IRIS Downloads", path: "/iris-downloads", restricted: false },
    { icon: StoreBtn, label: "Nearby Stores", path: "/nearby-stores", restricted: false },
  ];
    const adminRolesCheck = chains
    ?.flatMap(
      (chain) =>
        chain.roles?.filter((role: { role_name: string }) =>
          ["Internal Project Admin", "External Project Admin", "AB System Admin"].includes(
            role.role_name
          )
        ) || []
    )
    .filter(Boolean);

  const hasChainProjectAdminRole =
    (adminRolesCheck?.some((role: { role_name: string }) =>
      ["Internal Project Admin", "External Project Admin"].includes(role.role_name)
    ) ?? false);

  const isAuthProjectAdmin =
    effectiveUserRole === Constants.INTERNAL_PROJECT_ADMIN ||
    effectiveUserRole === Constants.EXTERNAL_PROJECT_ADMIN;

  const canSeeManageData =
    effectiveUserRole === Constants.AB_SYSTEM_ADMIN ||
    hasChainProjectAdminRole ||
    (isAuthProjectAdmin && hasManageDataAccess);

  const canSeeAnnouncements = effectiveUserRole === Constants.AB_SYSTEM_ADMIN || hasChainProjectAdminRole;

  // Restricted admin-only actions
  const restrictedActions = [
    // { icon: IRISBtn, label: "IRIS Downloads", path: "/iris-downloads", restricted: false },
    ...(canSeeManageData
      ? [{ icon: ManageDataBtn, label: "Manage Data", path: "/manage-all-data", restricted: true }]
      : []),
    ...(canSeeAnnouncements
      ? [{
          icon: AnnouncementAdminBtn,
          label: "Announcements",
          path:
        effectiveUserRole === Constants.AB_SYSTEM_ADMIN || hasChainProjectAdminRole
          ? "/announcements-new"
          : "/announcements/me",
          restricted: true,
        }]
      : []),
  ];
  // visible at the end — count badge
  const manageRequestAction = {
    icon: ManageRequest,
    label: "Manage Requests",
    path: "/manage-requests",
    restricted: false,
    count: activeRequestCount,
  };
  const irisAction = {
    icon: IRISBtn,
    label: "IRIS Downloads",
    path: "/iris-downloads",
    restricted: false,
  };

  // Check role conditions
  const isSystemAdmin = effectiveUserRole === Constants.AB_SYSTEM_ADMIN;

  const hasAdminRole = chains?.some((chain) =>
    chain.roles?.some((role: { role_name: string }) => {
      return ["Internal Project Admin", "External Project Admin", "AB System Admin"].includes(
        role.role_name
      );
    })
  );

  const adminRoles = chains
    ?.flatMap(
      (chain) =>
        chain.roles?.filter((role: { role_name: string }) =>
          ["Internal Project Admin", "External Project Admin", "AB System Admin"].includes(
            role.role_name
          )
        ) || []
    )
    .filter(Boolean);

  setItem("projectAdmin", adminRoles);

  const allowedRoles = ["Internal Project Admin", "External Project Admin"];

const selectedRole = adminRoles?.find(role => allowedRoles.includes(role.role_name));


if(selectedRole && selectedRole!==undefined && selectedRole!=='undefined'){
  setItem("chainRole",selectedRole)
}

  // visible actions
  let visibleActions: Array<{ icon: any; label: string; path: string; restricted: boolean; count?: number }> = [...baseActions];
  
  // IRIS always FIRST if accessible
  const canSeeIris =
    (isSystemAdmin && !hasAdminRole) || irisPermission;
  if (canSeeIris) {
    visibleActions = [irisAction, ...visibleActions.filter(a => a.label !== "IRIS Downloads")];
  }

  // Other admin actions
  if (isSystemAdmin || hasAdminRole || canSeeManageData) {
    const others = restrictedActions.filter(
      action => action.label !== "IRIS Downloads"
    );
    visibleActions = [...visibleActions, ...others];
  }
  visibleActions = [...visibleActions, manageRequestAction];

  return (
    <section
      style={{
        borderRadius: "1rem",
        padding: "1.5rem 0 0 0",
        width: "100%",
        maxWidth: "64rem",
        display: "flex",
        justifyContent: "start",
        flexWrap: "wrap" as const,
        gap: "1rem",
      }}
    >
      {visibleActions.map((action) => (
        <div
          key={action.label}
          style={{ position: "relative", display: "inline-block" }}
          onClick={() => history.push(action.path)}
        >
          <ActionCard icon={action.icon} label={action.label} />
          {action.count !== undefined && action.count > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-0.8em",
                right: "6%",
                backgroundColor: "#D1A33C",
                color: "#fff",
                borderRadius: "50%",
                minWidth: "clamp(16px, 1.5vw, 22px)",
                height: "clamp(16px, 1.5vw, 22px)",
                fontSize: "clamp(9px, 0.75vw, 12px)",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10,
                lineHeight: 1,
                padding: "0 3px",
                pointerEvents: "none",
              }}
            >
              {action.count > 99 ? "99+" : action.count}
            </span>
          )}
        </div>
      ))}
    </section>
  );
};

const QuickActions = withRouter(QuickActionsComponent) as React.ComponentType<QuickActionsOwnProps>;

export default QuickActions;
